// src/services/CategoryService.ts
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BASE_URL+'/categories';

export interface Category {
  id?: number;
  name: string;
  description?: string;
}

export const CategoryService = {
  createCategory: async (category: Category) => {
    const response = await axios.post(API_BASE_URL, category);
    return response.data;
  },

  getAllCategories: async (): Promise<Category[]> => {
    const response = await axios.get(API_BASE_URL);
    return response.data;
  },

  getCategoryById: async (id: number): Promise<Category> => {
    const response = await axios.get(`${API_BASE_URL}/${id}`);
    return response.data;
  },

  deleteCategory: async (id: number): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/${id}`);
  },

  updateCategory: async (id: number, category: Category): Promise<Category> => {
    const response = await axios.put(`${API_BASE_URL}/${id}`, category);
    return response.data;
  }
};
